import { __assign } from "tslib";
export var authSettingsApiRelativePath = "/helpcenter/auth";
export var createAuthSettingsApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + authSettingsApiRelativePath;
    return {
        getSettings: function (brandId) {
            return http.get("" + apiUrl + (brandId ? "?brandId=" + brandId : ''));
        },
        updateSettings: function (dto) {
            return http.put("" + apiUrl, dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
    };
};
//# sourceMappingURL=index.js.map